export default function CTA() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative py-32 my-32 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/3001e53e79007613e8c8b2076236cbc6.jpg"
          alt="CTA Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-12 text-center">
        <h2 className="text-5xl lg:text-6xl font-bold text-white uppercase tracking-wide mb-8">
          TRASFORMA IL TUO BUSINESS
        </h2>
        
        <p className="text-white text-xl font-light leading-relaxed max-w-3xl mx-auto mb-12">
          Contattaci per una consulenza gratuita e scopri come possiamo ottimizzare i tuoi processi aziendali con soluzioni tecnologiche innovative
        </p>
        
        <button
          onClick={() => scrollToSection('contatti')}
          className="inline-flex items-center gap-4 bg-black text-white px-12 py-5 rounded-full font-medium hover:scale-105 transition-all cursor-pointer group"
        >
          <div className="w-12 h-12 rounded-full bg-[#FF6B35] flex items-center justify-center">
            <i className="ri-mail-line text-white text-xl"></i>
          </div>
          <span className="text-lg uppercase tracking-wide whitespace-nowrap">CONTATTACI ORA</span>
          <i className="ri-arrow-right-up-line text-2xl group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"></i>
        </button>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-20 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-4xl lg:text-5xl font-bold text-white mb-2">24/7</div>
            <p className="text-white/80 font-light">Supporto Disponibile</p>
          </div>
          <div className="text-center">
            <div className="text-4xl lg:text-5xl font-bold text-white mb-2">98%</div>
            <p className="text-white/80 font-light">Soddisfazione Clienti</p>
          </div>
          <div className="text-center">
            <div className="text-4xl lg:text-5xl font-bold text-white mb-2">&lt;48h</div>
            <p className="text-white/80 font-light">Tempo di Risposta</p>
          </div>
          <div className="text-center">
            <div className="text-4xl lg:text-5xl font-bold text-white mb-2">ISO</div>
            <p className="text-white/80 font-light">Certificazioni Qualità</p>
          </div>
        </div>
      </div>
    </section>
  );
}
